import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-up-and-down-arrows';
export var ID = 'icon-up-and-down-arrows';
/* eslint-disable max-len */

export var SVGUpAndDownArrows = function SVGUpAndDownArrows() {
  return React.createElement("symbol", {
    id: ID,
    width: "8",
    height: "20",
    viewBox: "0 0 8 20"
  }, React.createElement("g", {
    transform: "translate(0,-1032.3622)"
  }, React.createElement("g", {
    transform: "matrix(1.0052379,0,0,1.0669467,-0.21318935,1072.2038)"
  }, React.createElement("g", {
    transform: "translate(-0.00373546,-15.490157)"
  }, React.createElement("path", {
    d: "m 2.9328611,-18.161699 c 0.841407,0 1.6828139,0 2.5242209,0 0,1.351741 0,2.703482 0,4.055223 -0.841407,0 -1.6828139,0 -2.5242209,0 0,-1.351741 0,-2.703482 0,-4.055223 z"
  }), React.createElement("path", {
    d: "m 4.194971,-21.851555 c 1.326386,1.254316 2.652772,2.508632 3.979158,3.762948 -2.6527717,0 -5.3055434,0 -7.95831504,0 1.32638564,-1.254316 2.65277134,-2.508632 3.97915704,-3.762948 z"
  })), React.createElement("g", {
    transform: "matrix(-1,0,0,-1,8.3862075,-40.448189)"
  }, React.createElement("path", {
    d: "m 2.9328611,-18.161699 c 0.841407,0 1.6828139,0 2.5242209,0 0,1.351741 0,2.703482 0,4.055223 -0.841407,0 -1.6828139,0 -2.5242209,0 0,-1.351741 0,-2.703482 0,-4.055223 z"
  }), React.createElement("path", {
    d: "m 4.194971,-21.851555 c 1.326386,1.254316 2.652772,2.508632 3.979158,3.762948 -2.6527717,0 -5.3055434,0 -7.95831504,0 1.32638564,-1.254316 2.65277134,-2.508632 3.97915704,-3.762948 z"
  })))));
};
/* eslint-disable max-len */

var UpAndDownArrows = function UpAndDownArrows(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGUpAndDownArrows
  });
};

UpAndDownArrows.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default UpAndDownArrows;